export const STOP_MICROPHONE = 'STOP_MICROPHONE';